import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { navigate } from 'gatsby';
import SvgRoller from '../../fromSvg/SvgRoller';
import Button from '../../Button';
import DefaultParagraph from '../../DefaultParagraph';
import DefaultTitle from '../../DefaultTitle';
import SvgSmallFooterRoller from '../../fromSvg/SvgSmallFooterRoller';


const OrderContainer = styled.div<{ withoutOrderFooter?: boolean }>`
  background-color: ${({ theme }) => theme.colors.gray};
  display: flex;
  flex-direction: column;
  position: relative;
  flex-wrap: nowrap;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 120px 0 120px 20px;
    margin-left: -100px;
  }
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    padding: 120px 0 120px 70px;
    margin-left: 0;
  }
`;

const RollerContainer = styled.div`
  display: none;
  height: 300px;
  width: 540px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    display: inline;
  }
  @media(min-width: 1350px){
    margin-bottom: 0;
  }
`;

const VerticalRollerContainer = styled(SvgSmallFooterRoller)`
  margin-bottom: 35px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}){
    margin-top: -450px
  }
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.small}){
    margin-top: -650px
  }
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    display: none;
  }
`;

const OrderFreeQuote = styled.div`
  height: 247.57px;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  color: ${({ theme }) => theme.colors.dark};
  width: 100%;
  padding: 40px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    position: static;
    padding: 20px;
    background-color: ${({ theme }) => theme.colors.white};
    align-self: flex-end;
    margin-left: 25px;
    flex-direction: row;
  }
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    padding: 40px;
  }
`;

const OrderFreeQuoteTextContent = styled.span`
  margin-bottom: 60px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    margin-right: 5px;
    max-width: 600px;
    margin-bottom: 0;
  }
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    margin-right: 20px;
  }
`;

const StyledDefaultParagraph = styled(DefaultParagraph)`
  /* stylelint-disable-next-line */
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}) and (max-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    margin-bottom: 5px;
  }
`;

const StyledDefaultTitle = styled(DefaultTitle)`
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    margin-bottom: 5px;
    margin-right: -130px;
  }
`;

const StyledButton = styled(Button)`
  /* stylelint-disable-next-line */
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}) and (max-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    min-width: 130px;
  }
`;

interface FreeOrderSectionProps {
  withoutOrderFooter?: boolean,
}

const FreeOrderSection = ({ withoutOrderFooter }: FreeOrderSectionProps) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      {!withoutOrderFooter && (
        <OrderContainer>
          <VerticalRollerContainer />
          <RollerContainer>
            <SvgRoller />
          </RollerContainer>
          <OrderFreeQuote>
            <OrderFreeQuoteTextContent>
              <StyledDefaultTitle color={theme.colors.dark}>
                ZAMÓW DARMOWĄ WYCENĘ
              </StyledDefaultTitle>
              <StyledDefaultParagraph color={theme.colors.dark}>
                Obejrzymy Twoją nieruchomość i zrobimy wycenę prac.
              </StyledDefaultParagraph>
              <StyledDefaultParagraph color={theme.colors.dark}>
                Jeżeli mieszkasz dalej niż 30 km od Trójmiasta, rozliczymy się tylko za paliwo,
                sama wycena jest darmowa.
              </StyledDefaultParagraph>
              <StyledDefaultParagraph color={theme.colors.dark}>
                Koszt ewentualnego dojazdu zostanie odliczony od kosztu remontu w razie zawarcia
                umowy.
              </StyledDefaultParagraph>
            </OrderFreeQuoteTextContent>
            <StyledButton onClick={() => navigate('/kontakt')}>
              Umów się
            </StyledButton>
          </OrderFreeQuote>
        </OrderContainer>
      )}
    </>
  );
};

export default FreeOrderSection;
